export default __webpack_public_path__ + "static/en1-be83afb5645cd8ad770c3682ff4f3906.png";